import { Box, Button, Chip, Divider, Typography } from "@material-ui/core"
import DialogComponent from "../../../components/Dialog"
import { WarningRounded } from "@material-ui/icons"
import { useHistory, NavLink } from "react-router-dom";

export const PendingIndexationAlert = ({ open, tenant, onCancel }) => {
    const history = useHistory();

    return <DialogComponent title="Pending Indexation" open={open} onClose={onCancel}>
        <br/>
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 2,
                borderRadius: 3,
                background:
                    "linear-gradient(135deg, rgba(255,179,71,0.12) 0%, rgba(255,71,87,0.10) 100%)",
                //   border: "1px solid",
                //   borderColor: "divider",
                mb: 2,
            }}
        >
            <Box
                sx={{
                    width: 60,
                    height: 44,
                    borderRadius: "50%",
                    display: "grid",
                    placeItems: "center",
                    background:
                        "linear-gradient(135deg, rgba(255,179,71,0.35) 0%, rgba(255,71,87,0.35) 100%)",
                }}
                mr={3}
            >
                <WarningRounded fontSize="medium" />
            </Box>

            <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    We found a pending indexation against <strong>{tenant?.name}</strong>.
                    Until you take action, editing this tenant is temporarily locked.
                </Typography>
            </Box>
        </Box>

        {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2, px: 0.5 }}>
        <Chip
          size="small"
          label={`${pendingCount} pending ${pendingCount === 1 ? "item" : "items"}`}
          color="warning"
          variant="outlined"
        />
        {tenant?.fullName && (
          <Chip size="small" label={tenant?.fullName} variant="outlined" />
        )}
      </Box> */}
        <br/>
        <br/>
        <Divider sx={{ mb: 2 }} />


        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                gap: 1.5,
            }}
        >
            <Button
                variant="contained"
                //   onClick={() => onGoToIndexations?.()}
                sx={{ py: 1.1, borderRadius: 2 }}
                to={"/"}
                component={NavLink}

            >
                Go to Indexations
            </Button>
            <Button
                variant="text"
                color="inherit"
                onClick={onCancel}
                sx={{ py: 1.1, borderRadius: 2 }}
            >
                Cancel
            </Button>
        </Box>
        
    </DialogComponent>
}